import { Center, Flex, Heading, Text } from '@podiumhq/design-system';

const BundleCardHeading = ({
  headerStyles = defaultHeadingStyles,
  headerText,
  popularText,
  popularTextProps = {},
  popularTextWrapperProps = {},
}) =>
  popularText ? (
    <Flex justify="space-between">
      <Heading {...headerStyles}>{headerText}</Heading>
      <Center backgroundColor="blue.lightest" {...popularTextWrapperProps}>
        <Text color="blue.base" fontWeight="medium" {...popularTextProps}>
          {popularText}
        </Text>
      </Center>
    </Flex>
  ) : (
    <Heading {...headerStyles}>{headerText}</Heading>
  );

const defaultHeadingStyles = {
  fontSize: '2xl',
  fontWeight: 'semibold',
  lineHeight: '40px',
};

export default BundleCardHeading;
